import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, components, icons, sizes } from '@/utils'

import render from './render'

export default {
  name: 'ButtonCopy',

  props: {
    value: [ String, Number ],

    mode: {
      type: String,
      default: buttonModes.flat,
      validator: value => {
        return Object.values(buttonModes).includes(value)
      }
    },

    size: {
      type: String,
      default: sizes.medium,
      validator: value => {
        return Object.values(sizes).includes(value)
      }
    },

    color: {
      type: String,
      default: Colors.primary,
      validator: value => {
        return Object.values(Colors).includes(value)
      }
    },

    icon: String,
    iconSVG: {
      type: String,
      default: 'copy'
    },

    tooltip: String,
    loading: Boolean,
    disabled: Boolean,

    small: Boolean,
    large: Boolean,

    label: String,

    view: {
      type: String,
      default: 'button',
      validator: value => {
        return [ 'button', components['list-item'] ].includes(value)
      }
    },

    snackbar: {
      type: Object,
      default: undefined
    }
  },

  data() {
    return {
      buttonCallback: undefined
    }
  },

  computed: {
    iconSize() {
      if (this.small) {
        return 16
      }
      if (this.large) {
        return 22
      }

      return 18
    },

    $snackbar() {
      if (this.snackbar) {
        return this.snackbar
      }

      return {
        text: this.getTranslate('misc.copied'),
        type: Colors.success
      }
    },

    $props() {
      const result = {
        mode: this.mode,
        size: this.size,
        color: this.color,
        label: this.label,
        tooltip: this.tooltip,
        loading: this.loading,
        disabled: this.disabled
      }

      result.icon = this.icon
      result.iconSVG = undefined
      if (!this.icon) {
        result.iconSVG = this.iconSVG
      }

      if (this.buttonCallback) {
        result.icon = icons.done
        result.iconSVG = undefined
        result.color = Colors.success
      }

      return result
    }
  },

  methods: {
    clickHandler() {
      navigator.clipboard.writeText(this.value)
      this.addSnackbar(this.$snackbar)

      this.buttonCallback = true
      setTimeout(() => {
        this.buttonCallback = undefined
      }, 1000)
    }
  },

  render
}
